// extracted by mini-css-extract-plugin
export default {"productGallery":"iQ-z","inQuickShop":"jQ-z"};